/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Standard_Feature_5Inputs */

const et_plan_standard_feature_5 = /** @type {(inputs: Plan_Standard_Feature_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kvaliteetsed tagalingid`)
};

const en_plan_standard_feature_5 = /** @type {(inputs: Plan_Standard_Feature_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`High-quality backlinks`)
};

/**
* | output |
* | --- |
* | "High-quality backlinks" |
*
* @param {Plan_Standard_Feature_5Inputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const plan_standard_feature_5 = /** @type {((inputs?: Plan_Standard_Feature_5Inputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Standard_Feature_5Inputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_plan_standard_feature_5(inputs)
	return en_plan_standard_feature_5(inputs)
});